import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { version as CURRENT_VERSION } from "../../../package.json";

const RELEASE_NOTES_URL = "https://s3.us-east-2.amazonaws.com/jobvious.digitalassets/Jobvious_Release_Notes.pdf";

const VersionChecker = () => {
  const [showModal, setShowModal] = useState(false);
  const updateAvailable = useRef(false);
  const newVersion = useRef(null);
  const location = useLocation();
  const isFirstRoute = useRef(true);

  // Fetch meta.json and check for version mismatch
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    const checkVersion = async () => {
      try {
        const res = await fetch(`/meta.json?t=${Date.now()}`, {
          cache: "no-store",
        });
        const data = await res.json();

        if (data.version && data.version !== CURRENT_VERSION) {
          updateAvailable.current = true;
          newVersion.current = data.version;
        }
      } catch (err) {
        console.error("Version check failed:", err);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // On route change, show modal if update is available
  useEffect(() => {
    // Skip the initial mount — don't block the first page load
    if (isFirstRoute.current) {
      isFirstRoute.current = false;
      return;
    }

    if (updateAvailable.current) {
      setShowModal(true);
    }
  }, [location.pathname]);

  const handleUpdate = () => {
    // Store flag so we can show toast after reload
    localStorage.setItem("jobvious_updated_version", newVersion.current || "latest");

    // Clear service worker caches
    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }

    // Force hard reload
    window.location.reload(true);
  };

  if (!showModal) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "32px",
          maxWidth: "420px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
      >
        <div style={{ fontSize: "40px", marginBottom: "16px" }}>
          <i className="fas fa-arrow-up-from-bracket" style={{ color: "#0d6efd" }}></i>
        </div>
        <h4 style={{ marginBottom: "8px", color: "#333" }}>Update Available</h4>
        <p style={{ color: "#666", marginBottom: "24px", fontSize: "14px" }}>
          A new version of Jobvious is ready. Please update to continue.
        </p>
        <button
          onClick={handleUpdate}
          className="btn btn-primary btn-lg"
          style={{ width: "100%", fontWeight: "bold" }}
        >
          Update Now
        </button>
        <a
          href={RELEASE_NOTES_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", marginTop: "12px", fontSize: "13px", color: "#666" }}
        >
          View Release Notes
        </a>
      </div>
    </div>
  );
};

export default VersionChecker;
